'use client';

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import ReactMarkdown from "react-markdown";

import { VolumeIcon } from "@/components/fun-ui/icons";
import { externalMarkdownLink } from "@/components/md-components";
import {
  syncSystemAnnouncementForPath,
  useSystemAnnouncementDisplay,
} from "@/stores/appStore";
import { cn } from "@/lib/utils";

const barClassName =
  "flex flex-row h-10 max-h-10 bg-[#F8E9E2] items-center justify-center gap-2 text-[#FF6700]";

export function SystemAnnouncement() {
  const pathname = usePathname();
  const { content, linkto } = useSystemAnnouncementDisplay();

  useEffect(() => {
    void syncSystemAnnouncementForPath(pathname);
  }, [pathname]);

  if (!content) {
    return null;
  }

  const body = (
    <>
      <VolumeIcon className="shrink-0" />
      {linkto ? (
        <span className="text-sm truncate">{content}</span>
      ) : (
        <ReactMarkdown components={externalMarkdownLink}>{content}</ReactMarkdown>
      )}
    </>
  );

  const isExternal = linkto ? /^https?:\/\//i.test(linkto) : false;

  return (
    <div
      className={cn(
        barClassName,
        "relative z-[5] shrink-0 grow-0 overflow-hidden pointer-events-none",
      )}
    >
      {linkto ? (
        <a
          href={linkto}
          className="inline-flex max-w-full items-center justify-center gap-2 cursor-pointer no-underline hover:opacity-90 pointer-events-auto"
          {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          {body}
        </a>
      ) : (
        <div className="pointer-events-auto inline-flex max-w-full items-center justify-center gap-2">
          {body}
        </div>
      )}
    </div>
  );
}
